import { Phone } from 'lucide-react';
import { WHATSAPP_HREF, WhatsAppIcon } from '@/components/WhatsAppButton';

const PHONE_DISPLAY = '0208 935 5492';
const PHONE_HREF = 'tel:02089355492';

export default function CampaignTopBar() {
  return (
    <div className="sticky top-20 z-40 mt-20 bg-navy-dark text-white border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between gap-3 py-2.5">
          <span className="caps-label text-white/70 hidden sm:block">Speak to an inventory clerk now</span>
          <div className="flex items-center gap-2.5 sm:gap-5 ml-auto">
            <a
              href={PHONE_HREF}
              className="inline-flex items-center gap-2 text-base sm:text-lg font-bold text-orange hover:text-orange-light transition-colors"
            >
              <Phone size={18} strokeWidth={2.5} />
              {PHONE_DISPLAY}
            </a>
            <span className="h-5 w-px bg-white/20" aria-hidden="true" />
            <a
              href={WHATSAPP_HREF}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chat with Daley Inventories on WhatsApp"
              className="inline-flex items-center gap-2 text-sm sm:text-base font-semibold text-[#25D366] hover:text-[#1da851] transition-colors"
            >
              <WhatsAppIcon className="w-5 h-5" />
              <span className="hidden sm:inline">WhatsApp</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}